import {
  aiAnalyzedFileSchema,
  AiAnalyzedFileSource,
} from "@redotech/redo-model/ai-analyzed-file";
import { z } from "zod";

export const getAiAnalyzedFiles = {
  input: z.object({ source: z.nativeEnum(AiAnalyzedFileSource).optional() }),
  output: z.array(aiAnalyzedFileSchema),
};

export const getAiAnalyzedFileContent = {
  input: z.object({ fileUrl: z.string() }),
  output: z.object({ content: z.string() }),
};
